module.exports = __webpack_public_path__ + "media/img/event/speakers/Matthew-headshot-16376e928f2b4f2dbce83ca4aca43dec.jpg";